import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LayersIcon, BookOpenIcon } from "lucide-react";

export function MainNav({ className }: { className?: string }) {
  return (
    <div className="w-full flex items-center justify-between">
      <div className={cn("flex items-center", className)}>
        <Link
          to="/"
          className="flex items-center gap-2.5 text-xl font-semibold transition-colors hover:text-primary"
        >
          <LayersIcon className="h-6 w-6 flex-shrink-0" />
          <span className="font-space whitespace-nowrap">LLM Gateway</span>
        </Link>
      </div>
      <div className="hidden md:block mr-4">
        <Link 
          to="/docs" 
          className="flex items-center gap-1.5 text-sm font-medium text-white bg-iris-600 hover:bg-iris-700 transition-colors px-5 py-2 rounded-md shadow-sm"
        >
          <BookOpenIcon size={18} />
          <span>Documentation</span>
        </Link>
      </div>
    </div>
  );
}
